export default function SubmitLoader() {
  return (
      <i className="fa-solid fa-sync fa-spin"></i>
  );
}
